var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24Z",
    fill: "#E62048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 46.9631C7.15981 43.9673 0 34.8198 0 24C0 13.1802 7.15981 4.0327 17 1.03687V46.9631Z",
    fill: "#03803D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31.7C21.2526 31.7 24.7 28.2526 24.7 24C24.7 19.7474 21.2526 16.3 17 16.3C12.7474 16.3 9.3 19.7474 9.3 24C9.3 28.2526 12.7474 31.7 17 31.7Z",
    stroke: "#FADF43",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.3H13.3V21V26.6667C13.3 27.7896 14.2104 28.7 15.3333 28.7H18.6667C19.7896 28.7 20.7 27.7896 20.7 26.6667V21V20.3H20H14Z",
    fill: "#fff",
    stroke: "#E62048",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z",
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgPt;